import { render, staticRenderFns } from "./BasicSalesReport.vue?vue&type=template&id=447d44fb&"
import script from "./BasicSalesReport.vue?vue&type=script&lang=js&"
export * from "./BasicSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports